import { ofType } from "redux-observable";
import { of, from } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_USERS_BEGIN, fetchUsersSuccess, logError, fetchAvatars } from "../actions";
import SocialAPIUtils from "../utils/SocialAPIUtils";
export default function fetchUsers(action$, state$) {
    return action$.pipe(ofType(FETCH_USERS_BEGIN), mergeMap(function(action) {
        return from(SocialAPIUtils.getAllUsers(action.term)).pipe(switchMap(function(users) {
            return [
                fetchUsersSuccess({
                    users: users
                }),
                fetchAvatars({
                    foreign_ids: users.map(function(u) {
                        return u.foreign_id;
                    })
                })
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_users"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_users"
        }));
    }));
}
